import { Form } from '@percent/admin-dashboard/api/actions/grantProgram/grantProgram.types'

export const mockGrantProgramForms: Form[] = [
  {
    id: '1',
    title: 'Form 1',
    type: 'Form 1 type',
    deadline: '2025-06-09',
    internalName: 'Form 1'
  },
  {
    id: '2',
    title: 'Form 2',
    type: 'Form 2 type',
    deadline: '2025-06-15',
    internalName: 'Form 2'
  },
  {
    id: '3',
    title: 'Form 3',
    type: 'Form 3 type',
    deadline: '2025-06-21',
    internalName: 'Form 3'
  },
  {
    id: '4',
    title: 'Form 4',
    type: 'Form 4 type',
    deadline: '2025-06-28',
    internalName: 'Form 4'
  }
]
